const pluralize = (c: number, label: string): string => {
    if (c > 1) {
        return `${c} ${label}s`;
    }

    return `${c} ${label}`;
};

export default pluralize;
